import React from 'react';
import { Fade } from 'react-reveal';
import './Footer.css';

const Footer = () => {
  return (
    <div className='footer-div'>
      <Fade>
        <footer>
          <p className='footer-text'>Made by Ollivier Julles Morales</p>
        </footer>
      </Fade>
    </div>
  );
};

export default Footer;
